// ISO 3166 Alpha-2 country codes for Xendit supported countries
export const COUNTRIES = [
  { code: 'ID', name: 'Indonesia' },
  { code: 'PH', name: 'Philippines' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'TH', name: 'Thailand' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'SG', name: 'Singapore' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'MX', name: 'Mexico' },
];

// Helper function to get country name by code
export const getCountryName = (code) => {
  const country = COUNTRIES.find(c => c.code === code);
  return country ? country.name : code;
};

// Helper function to get country by code
export const getCountry = (code) => {
  return COUNTRIES.find(c => c.code === code);
};

// Helper function to format country display
export const formatCountryDisplay = (code) => {
  const country = getCountry(code);
  return country ? `${country.name} (${country.code})` : code;
};
